"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EntityBase {
    constructor(id, entityData) {
        this.id = id;
        if (entityData) {
            for (let key in entityData) {
                if (key === 'id') {
                    continue;
                }
                this[key] = entityData[key];
            }
        }
    }
}
exports.EntityBase = EntityBase;
//# sourceMappingURL=EntityBase.js.map